import dayjs from "dayjs";

/** Whether two dates fall on the same calendar day (ignores time-of-day). */
export const isSameDay = (debut: string, fin: string): boolean => {
  const dateDebut = dayjs(debut).format("DD/MM/YYYY");
  const dateFin = dayjs(fin).format("DD/MM/YYYY");
  return dateDebut === dateFin;
};

/** Whether the given date is after the current moment. */
export const isInFuture = (date: string): boolean => {
  return dayjs(date).isAfter(dayjs());
};

/**
 * Whether an activity starting at `date` should be considered "started" — true until 6h after
 * `date`, used to still show an activity as ongoing for a while after its nominal start time.
 */
export const IsStarted = (date: string): boolean => {
  return dayjs(dayjs()).isBefore(dayjs(date).add(6, "hour"));
};
